import { render, staticRenderFns } from "./BenchScoreCard.vue?vue&type=template&id=7daa4b47&scoped=true&"
import script from "./BenchScoreCard.vue?vue&type=script&lang=js&"
export * from "./BenchScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./BenchScoreCard.vue?vue&type=style&index=0&id=7daa4b47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daa4b47",
  null
  
)

export default component.exports